<template>
  <div>
    <!-- Modal -->
    <b-modal ref="activityNotesModal" size="xl" title="Activities and Notes" hide-footer>
      <template v-slot:modal-header="{ close }">
        <div class="row" style="width: 100%;">
          <div class="col-12">
            <div>
              <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                assignment
              </i>
            </div>
            <div class="wd-modal-subheader">
              <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Activities and Notes</h3>
            </div>
            <button type="button" class="close" @click="close()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="wd-modal-body">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :width="50"
                 :height="50"
                 :is-full-page="false">
        </loading>

        <!-- Search Section -->
        <div class="row mb-3">
          <div class="col-md-4">
            <input type="text"
                   class="form-control"
                   placeholder="Search activities and notes..."
                   v-model="searchQuery"
                   @input="performSearch">
          </div>
          <div class="col-md-8 text-right">
            <button class="btn btn-success btn-sm mr-2" @click="openAddActivityModal">
              <i class="fa fa-plus"></i> Add
            </button>
            <button class="btn btn-info btn-sm mr-2" @click="expandAll">
              <i class="fa fa-expand"></i> Expand All
            </button>
            <button class="btn btn-warning btn-sm mr-2" @click="collapseAll">
              <i class="fa fa-compress"></i> Collapse All
            </button>
            <button class="btn btn-secondary btn-sm" @click="refreshData">
              <i class="fa fa-refresh"></i> Refresh
            </button>
          </div>
        </div>

        <!-- Activities Table -->
        <div class="table-responsive">
          <table id="activities_notes_table" class="display" style="width:100%">
            <thead>
              <tr>
                <th class="all">Date</th>
                <th class="all">Activity</th>
                <th class="none">Type</th>
                <th class="none">Note</th>
                <th class="none">Assigned To</th>
                <th class="none">Contact</th>
                <th class="none">Follow Up</th>
                <th class="none">Created By</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <!-- Add Activity/Note Modal -->
    <AddActivityNoteModal ref="addActivityNoteModal"
                          :jobId="jobId"
                          :activities="activities"
                          :contacts="contacts"
                          :users="users"
                          @activityAdded="onActivityAdded" />

    <!-- Edit Activity/Note Modal -->
    <EditActivityNoteModal ref="editActivityNoteModal"
                           :activities="activities"
                           :contacts="contacts"
                           :users="users"
                           @activityUpdated="onActivityUpdated" />
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue';
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CommonConstants from '@/constants/constants.js'
import AddActivityNoteModal from './AddActivityNoteModal.vue'
import EditActivityNoteModal from './EditActivityNoteModal.vue'

export default {
  name: 'ActivityAndNotesModal',
  components: {
    Loading,
    AddActivityNoteModal,
    EditActivityNoteModal
  },
  props: {
    jobId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      constants: CommonConstants,
      isLoading: false,
      searchQuery: '',
      activitiesData: [],
      dataTable: null,
      searchTimeout: null,
      activities: [],
      contacts: [],
      users: []
    }
  },
  computed: {
    header() {
      return {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
    }
  },
  beforeDestroy() {
    if (this.dataTable) {
      $('#activities_notes_table tbody').off('click', 'tr')
      this.dataTable.destroy()
      this.dataTable = null
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  methods: {
    show() {
      this.$refs.activityNotesModal.show()
      this.$nextTick(() => {
        this.loadDropdownData()
        this.initializeDataTable()
        this.loadActivitiesData()
      })
    },
    hide() {
      this.$refs.activityNotesModal.hide()
      if (this.dataTable) {
        this.dataTable.destroy()
        this.dataTable = null
      }
    },
    async loadDropdownData() {
      try {
        const response = await axios.post(
          this.constants.api_url + 'job/view/' + this.jobId, { "fromImport": 1 },
          this.header
        )
        if (response.data.flag) {
          this.activities = response.data.data.activities_select || []
          this.contacts = response.data.data.contacts || []
          this.users = response.data.data.users || []
          console.log('Dropdown data loaded:', {
            activities: this.activities,
            contacts: this.contacts,
            users: this.users
          })
        }
      } catch (error) {
        console.error('Error loading dropdown data:', error)
      }
    },
    openAddActivityModal() {
      this.$refs.addActivityNoteModal.show()
    },
    onActivityAdded() {
      this.loadActivitiesData()
    },
    onActivityUpdated() {
      this.loadActivitiesData()
    },
    onRowClick(rowData) {
      if (rowData.type === 'system' || rowData.type === 'System') {
        Vue.$toast.error("Can't edit system activities", {
                position: 'top'
            });
        return
      }
      this.$refs.editActivityNoteModal.show(rowData)
    },
    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy()
      }

      const self = this
      this.dataTable = $("#activities_notes_table").DataTable({
        processing: true,
        serverSide: false,
        responsive: {
          details: {
            type: 'column',
            target: -1,
            renderer: function (api, rowIdx, columns) {
              var data = $.map(columns, function (col) {
                if (col.title == 'Note') {
                  return col.hidden ?
                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                    '<td><b>' + col.title + ':' + '</b></td> ' +
                    '<td style="white-space: normal;">' + col.data + '</td>' +
                    '</tr>' :
                    '';
                } else {
                  return col.hidden ?
                    '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                    '<td><b>' + col.title + ':' + '<b></td> ' +
                    '<td >' + col.data + '</td>' +
                    '</tr>' :
                    '';
                }
              }).join('');

              return data ?
                $('<table/>').append(data) :
                false;
            }
          }
        },
        columnDefs: [{
          className: 'control',
          orderable: false,
          targets: -1,
        }],
        "dom": '<"top">rit<"bottom"p><"clear">',
        destroy: true,
        orderClasses: false,
        "ordering": true,
        "paging": true,
        "pageLength": 25,
        language: {
          emptyTable: "No activities or notes found.",
          search: "Search:",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>'
          },
          sLengthMenu: "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        data: this.activitiesData,
        columns: [
          {
            data: "created_at",
            render: function(data) {
              if (data) {
                const date = new Date(data)
                return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
              }
              return ''
            }
          },
          { data: "activity" },
          { data: "type" },
          {
            data: "note",
            render: function(data) {
              return data || ''
            }
          },
          {
            data: "assign_name",
            render: function(data) {
              if (!data || data === null || data === '') {
                return '<i class="fa fa-ban" style="color: #6c757d; font-size: 18px;" title="Not assigned"></i>'
              }
              return data
            }
          },
          {
            data: "job_contacts_name",
            render: function(data) {
              if (!data || data === null || data === '') {
                return '<i class="fa fa-ban" style="color: #6c757d; font-size: 18px;" title="No contact"></i>'
              }
              return data
            }
          },
          {
            data: "follow_up",
            render: function(data) {
              if (data === '1' || data === 1) {
                return '<i class="fa fa-check-circle" style="color: #28a745; font-size: 18px;" title="Follow-up enabled"></i>'
              } else {
                return '<i class="fa fa-times-circle" style="color: #dc3545; font-size: 18px;" title="No follow-up"></i>'
              }
            }
          },
          { data: "created_by_name" },
          {
            render: function() {
              return ''
            }
          }
        ]
      })

      // Add click handler to rows (exclude control column)
      $('#activities_notes_table tbody').on('click', 'tr', function(e) {
        // Don't trigger on control column clicks (expand/collapse)
        if ($(e.target).hasClass('control') || $(e.target).closest('td').hasClass('control')) {
          return
        }
        const rowData = self.dataTable.row(this).data()
        if (rowData) {
          self.onRowClick(rowData)
        }
      })
    },
    async loadActivitiesData() {
      this.isLoading = true
      try {
        const requestData = {
          skip: 0,
          count: 1000, // Load more records for client-side processing
          search: {
            query: this.searchQuery
          },
          sort: {
            key: 'created_at',
            direction: 'desc'
          }
        }

        const response = await axios.post(
          this.constants.api_url + 'jobNote/action/' + this.jobId + '/0',
          requestData,
          this.header
        )

        if (response.data.flag) {
          this.activitiesData = response.data.data.data || []

          if (this.dataTable) {
            this.dataTable.clear()
            this.dataTable.rows.add(this.activitiesData)
            this.dataTable.draw()

            // Auto-expand all rows after data is loaded
            setTimeout(() => {
              this.expandAll()
            }, 200)
          }
        } else {
          this.activitiesData = []
        }
      } catch (error) {
        this.activitiesData = []
      } finally {
        this.isLoading = false
      }
    },
    performSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.loadActivitiesData() // This will auto-expand after loading
      }, 500)
    },
    refreshData() {
      this.searchQuery = ''
      this.loadActivitiesData() // This will auto-expand after loading
    },
    expandAll() {
      console.log('Expand All clicked')
      // Find all collapsed rows and click their control buttons
      const collapsedRows = $('#activities_notes_table tbody tr:not(.parent) td.control')
      console.log('Found collapsed rows:', collapsedRows.length)

      setTimeout(() => {
        collapsedRows.each(function() {
          console.log('Clicking control button to expand')
          $(this).click()
        })
      }, 100)
    },
    collapseAll() {
      console.log('Collapse All clicked')
      // Find all expanded rows and click their control buttons
      const expandedRows = $('#activities_notes_table tbody tr.parent td.control')
      console.log('Found expanded rows:', expandedRows.length)

      setTimeout(() => {
        expandedRows.each(function() {
          console.log('Clicking control button to collapse')
          $(this).click()
        })
      }, 100)
    }
  },
  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy()
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }
}
</script>

<style scoped>
.wd-modal-body {
  padding: 20px;
}

.wd-modal-subheader {
  display: inline-block;
  vertical-align: top;
  margin-top: 8px;
}

.table-responsive {
  margin-top: 15px;
}

.btn {
  margin-right: 5px;
}

/* DataTable responsive controls styling */
table.dataTable.dtr-column>tbody>tr>td.control:before {
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900;
  content: "\f13a "!important;
  background-color: white !important;
  color: #6495ED !important;
  box-shadow: none !important;
  border: none !important;
  cursor: pointer;
  line-height: 16px !important;
}

table.dataTable.dtr-column>tbody>tr.parent td.control:before {
  content: '\f139' !important;
  color: #d33333 !important;
  line-height: 16px !important;
}

@media (max-width: 768px) {
  .wd-modal-body {
    padding: 10px;
  }

  .table-responsive {
    font-size: 12px;
  }
}
</style>
